<template>
  <div>
    <div class="edit-wifi-modal">
      <div class="modal__container--header edit-wifi-modal__header">
        <div class="text">LTE Modem {{ header }}</div>
        <div class="close pointer">
          <span @click="close" class="mdi mdi-close"></span>
        </div>
      </div>
      <div class="edit-wifi-modal__container">
        <div class="edit-wifi-modal__container--row">
          <label style="line-height: 108%" class="switch">
            {{ translate("device.config_dashboard.modems.on") }}
            <!-- <span
              class="mdi mdi-help-circle-outline"
              style="font-size: 18px; color: #c3c7ca; position: relative"
              @mouseover="text_assistant.modem_on = true"
              @mouseleave="text_assistant.modem_on = false"
            >
              <span
                class="hide_text modem_on"
                :class="{ active: text_assistant.modem_on }"
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </span>
            </span> -->
            <input v-model="data.powered_on" type="checkbox" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="edit-wifi-modal__container--row">
          <div class="row__input">
            <label for="apn" class="inp">
              APN
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.apn = true"
                @mouseleave="text_assistant.apn = false"
              >
                <span
                  class="hide_text apn"
                  :class="{ active: text_assistant.apn }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input v-model="data.apn" type="text" class="text" id="apn" />
            </label>
          </div>
          <div style="max-width: 95px">
            <label class="switch">
              GPS
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.gps = true"
                @mouseleave="text_assistant.gps = false"
              >
                <span
                  class="hide_text gps"
                  :class="{ active: text_assistant.gps }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input v-model="data.gps" type="checkbox" />
              <span class="slider round"></span>
            </label>
          </div>
          <div style="max-width: 126px">
            <label class="switch">
              {{ translate("device.config_dashboard.modems.roaming") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.roaming = true"
                @mouseleave="text_assistant.roaming = false"
              >
                <span
                  class="hide_text roaming"
                  :class="{ active: text_assistant.roaming }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input
                v-model="data.allow_international_roaming"
                type="checkbox"
              />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <!-- <div class="edit-wifi-modal__container--row">
          <div class="row__input">
            <label for="username" class="inp">
              Username
              <span
                class=" mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.username = true"
                @mouseleave="text_assistant.username = false"
              >
                <span class="hide_text username" :class="{ active: text_assistant.username}">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span>
              <form id="ssid" method="post" autocomplete="off">
                <input
                  type="text"
                  class="text"
                  id="username"
                />
              </form>
            </label>
          </div>
          <div class="row__input">
            <label for="inp2" class="inp" style="position: relative">
              Password
              <span
                class=" mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.password = true"
                @mouseleave="text_assistant.password = false"
              >
                <span class="hide_text password" :class="{ active: text_assistant.password}">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span>
              <span
                style="font-size: 18px"
                :class="{ 'mdi-eye-off': isEyeClass }"
                class="show-password mdi mdi-eye"
              ></span>
              <form id="ssid" method="post" autocomplete="off">
                <input
                  type="password"
                  class="password"
                  id="inp2"
                  
                />
              </form>
            </label>
          </div>
        </div> -->
        <div class="edit-wifi-modal__container--row">
          <div class="row__input">
            <label for="Ping" class="inp">
              {{ translate("device.config_dashboard.modems.ping_servers") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.ping_servers = true"
                @mouseleave="text_assistant.ping_servers = false"
              >
                <span
                  class="hide_text ping_servers"
                  :class="{ active: text_assistant.ping_servers }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input
                type="text"
                v-model="data.ping_servers"
                class="text"
                id="Ping"
              />
            </label>
          </div>
          <div class="row__input">
            <label>
              {{ translate("device.config_dashboard.modems.work_mode") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.work_mode = true"
                @mouseleave="text_assistant.work_mode = false"
              >
                <span
                  class="hide_text work_mode"
                  :class="{ active: text_assistant.work_mode }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
            </label>
            <multiselect
              class="multiselect_test"
              :options="Mode"
              v-model="data.mode"
              :clear-on-select="false"
              :placeholder="''"
              :selectLabel="''"
              :selectedLabel="''"
              :deselectLabel="''"
              :searchable="false"
            />
          </div>
        </div>
        <div class="edit-wifi-modal__container--row">
          <div class="row__input">
            <label>
              {{ translate("device.config_dashboard.modems.wan_interfaces") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.wan_interfaces = true"
                @mouseleave="text_assistant.wan_interfaces = false"
              >
                <span
                  class="hide_text wan_interfaces"
                  :class="{ active: text_assistant.wan_interfaces }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
            </label>
            <multiselect
              class="multiselect_test"
              :options="listWanTunnels"
              v-model="data.wanTunnels"
              :multiple="true"
              :clear-on-select="false"
              :placeholder="''"
              :selectLabel="''"
              :selectedLabel="''"
              :deselectLabel="''"
              :searchable="false"
            />
          </div>
        </div>
      </div>
      <div class="edit-wifi-modal__buttons">
        <span>
          <button
            @click="close"
            style="margin-right: 10px"
            class="notice-btn btn-success btn btn-info"
          >
            {{ translate("btn.cancel") }}
          </button>
          <button @click="save" class="btn btn-success">
            {{ translate("btn.edit") }}
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Multiselect from "vue-multiselect";

export default Vue.extend({
  name: "ModemsModal",
  components: {
    Multiselect,
  },
  props: {
    dataModem: Object,
    header: String,
    listWanTunnels: Array,
  },
  data: function () {
    return {
      data: {},
      newData: {},
      old_apn: '',
      newWanList: [],
      selectedWanTunnels: [],
      isEyeClass: false,
      isPoweredOn: true,
      isGpsOn: false,
      isRoamingOn: false,
      selected_work_mode: "",
      text_assistant: {
        modem_on: false,
        apn: false,
        username: false,
        password: false,
        ping_servers: false,
        work_mode: false,
        wan_interfaces: false,
        gps: false,
        roaming: false,
      },
      Mode: ["5G", "LTE", "LTE3G", "3G", "2G", "AUTO"],
    };
  },
  methods: {
    save() {
      if (this.data.allow_international_roaming === true) {
        this.data.allow_international_roaming = "1";
      } else {
        this.data.allow_international_roaming = "0";
      }
      if (this.data.gps === true) {
        this.data.gps = "1";
      } else {
        this.data.gps = "0";
      }
      if (this.data.powered_on === true) {
        this.data.powered_on = "1";
      } else {
        this.data.powered_on = "0";
      }
      this.newData[this.header] = {
        allow_international_roaming: this.data.allow_international_roaming,
        apn: this.data.apn,
        gps: this.data.gps,
        mode: this.data.mode,
        ping_servers: this.data.ping_servers,
        powered_on: this.data.powered_on,
        old_apn: this.old_apn,
        wanTunnels: this.data.wanTunnels,
      };
      this.$emit("update", this.newData);
      this.$emit("close");
    },
    close() {
      this.$emit("close");
    },
  },
  created() {
    this.data = {
      powered_on: this.dataModem.powered_on || this.dataModem.power || "1",
      gps: this.dataModem.gps || "0",
      allow_international_roaming:
        this.dataModem.allow_international_roaming ||
        this.dataModem.allow_international ||
        "0",
      ping_servers:
        this.dataModem.ping_servers || this.dataModem.ping_server || [],
      mode: this.dataModem.mode || this.dataModem.net_mode || "AUTO",
      apn: this.dataModem.apn || "",
      wanTunnels: this.dataModem.wanTunnels || "",
    };
    this.old_apn = this.data.apn;
    if (this.data.gps == "On" || this.data.gps == "1") {
      this.data.gps = true;
    } else if (this.data.gps == "Off" || this.data.gps == "0") {
      this.data.gps = false;
    }
    if (
      this.data.allow_international_roaming == "On" ||
      this.data.allow_international_roaming == "1"
    ) {
      this.data.allow_international_roaming = true;
    } else if (
      this.data.allow_international_roaming == "Off" ||
      this.data.allow_international_roaming == "0"
    ) {
      this.data.allow_international_roaming = false;
    }
    if (this.data.powered_on == "On" || this.data.powered_on == "1") {
      this.data.powered_on = true;
    } else if (this.data.powered_on == "Off" || this.data.powered_on == "0") {
      this.data.powered_on = false;
    }
  },
});
</script>

<style src="assets/sass/radio-button.scss" lang="scss" scoped></style>
<style src="assets/sass/slider-round.scss" lang="scss" scoped></style>
<style src="assets/sass/show-hide-password.scss" lang="scss" scoped></style>

<style lang="scss" scoped>
.edit-wifi-modal {
  max-width: 600px;
  padding: 0;

  &__header {
    color: #66615b;
    font-size: 18px;
    padding: 26px 24px;
    border-bottom: 1px solid #cecfd1;
    display: flex;
    justify-content: space-between;
  }

  &__container {
    padding: 8px 24px;
    overflow-y: scroll;
    &--row {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin: 20px 0;
      label {
        margin-bottom: 0;
      }
      .row__label {
        color: gray;
        font-size: 13px;
        display: flex;
        margin-right: 24px;
      }
      .row__input {
        max-width: 268px;
        width: 100%;
        label {
          width: 100%;
        }
        span {
          color: #c3c7ca;
          font-size: 13px;
          font-weight: bold;
        }
        input {
          width: 100%;
          border: none;
          outline: none;
          padding: 0;
          height: 40px;
          font-size: 14px;
          font-weight: 400;
          background: none;
          border-radius: 0;
          color: #66615b !important;
          transition: all 0.4s ease;
          border-bottom: 1px solid #515459;
          background-color: transparent !important;
          font-family: Roboto, sans-serif;
          caret-color: #c3c7ca;
        }
      }
    }
    &--line {
      border-bottom: 1px solid gray;
      margin: 5px 0;
    }
  }

  &__buttons {
    border-top: 1px solid gray;
    padding: 24px;
    display: flex;
    justify-content: flex-end;
  }
}

.vue-select {
  .vs__dropdown-toggle {
    border: none !important;
    border-bottom: 1px solid #515459 !important;
    color: #c3c7ca;
    background: none;
  }
  input {
    color: #c3c7ca;
    padding: 0;
  }
}

.scanning {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(10px, 22px);
  padding: 7px 10px;
  color: white;
  border: none;
  background-color: #00a254;
}

@media (max-width: 600px) {
  .edit-wifi-modal {
    &__container {
      max-height: 400px;
      &--row {
        .row__input {
          max-width: 150px;
          &--3blocks {
            max-width: 100px !important;
          }
        }
      }
    }
  }
}

.hide_text {
  width: 300px;
  position: absolute;
  bottom: -43px;
  left: 85px;
  white-space: normal;
  background: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
  transition: 0.2s;
  box-shadow: 1px 1px 5px #202020;
  opacity: 0;
  z-index: -1;
  color: #c3c7ca;
  font-size: 13px;
  font-weight: bold;
  &.modem_on {
    bottom: -69px;
    left: 9px;
    //transform: translateX(200px);
  }
  /* &.imei {
    bottom: -75px;
    left: 10px;
  } */
  /* &.iccid {
    bottom: -75px;
    left: -293px;
  } */
  /* &.operator_name {
    bottom: 22px;
    left: 10px;
  } */
  &.apn {
    bottom: 22px;
    left: -289px;
  }
  &.username {
    bottom: -75px;
    left: 10px;
  }
  &.password {
    bottom: 22px;
    left: -293px;
  }
  &.ping_servers {
    bottom: 22px;
    left: 10px;
  }
  &.work_mode {
    bottom: 22px;
    left: -293px;
  }
  &.wan_interfaces {
    bottom: 22px;
    left: 10px;
  }
  &.gps {
    bottom: 22px;
    left: -293px;
  }
  &.roaming {
    bottom: 22px;
    left: -293px;
  }
  &.active {
    opacity: 1;
    z-index: 1;
    transform: translate(0, 0);
  }
}
</style>